import { VueNetwork } from './vue-network.js';
/**
 * This class is responsible for throwing any network stats error. Basically it provides two information:
 * <ul>
 *  <li>error: Actual error occurred and wrapped into it</li>
 *  <li>statsBeforeError: All the stats that are generated just before the error occurred</li>
 */
export class VueNetworkError extends Error {
    /**
     * All the stats that are generated just before the error occurred
     */
    statsUntil;
    /**
     * Constructor for creating VueNetworkError object
     * @param message Actual error wrapped into it.
     * @param statsUntil: All the stats that are generated just before the error occurred
     */
    constructor(message, statsUntil) {
        super(message);
        this.statsUntil = statsUntil;
        // Set the prototype explicitly.
        Object.setPrototypeOf(this, VueNetworkError.prototype);
    }
}
